export default {
  // Mining stats
  mining_maxDepth0: {
    achievement: 'This is deep',
    description: 'Maximum depth'
  },
  mining_maxDepth1: {
    achievement: 'Digging deeper',
    description: 'Maximum gas giant depth'
  },
  mining_maxDepthSpeedrun: {
    achievement: 'Deeprun',
    description: 'Maximum depth in under 15 minutes'
  },
  mining_depthDwellerCap0: {
    achievement: 'Drilling straight down',
    description: 'Maximum dweller depth'
  },
  mining_depthDwellerCap1: {
    achievement: 'Sparkless',
    description: 'Maximum gas dweller depth'
  },
  mining_totalDamage: {
    achievement: 'Destruction',
    description: 'Total damage dealt'
  },
  mining_maxDamage: {
    achievement: 'Power',
    description: 'Most damage in one hit'
  },
  mining_craftingCount: {
    description: 'Pickaxes crafted'
  },
  mining_scrap: {
    achievement: 'Scrapheap',
    description: 'Scrap gained'
  },
  mining_oreTotal: {
    achievement: 'More ore',
    description: 'Ore gained'
  },
  mining_oreVariety: {
    achievement: 'Diversity',
    description0: 'Ore types found',
    description1: 'Ore and rare earth types found',
    description2: 'Ore, rare earth and gas types found',
  },
  mining_coal: {
    achievement: 'Darkness',
    description: 'Coal gained'
  },
  mining_resin: {
    achievement: 'Sticky situation',
    description: 'Resin gained'
  },
  mining_gasTotal: {
    achievement: 'Hothead',
    description: 'Digit sum of highest gas amounts'
  },
  mining_smoke: {
    achievement: 'Hard to see',
    description: 'Highest smoke amount'
  },
  mining_enhancementHighest: {
    achievement: 'Prepared',
    description: 'Highest enhancement level'
  },
  mining_craftingWasted: {
    achievement: 'Wasted',
    description: 'Craft a pickaxe that cannot be better than your current one'
  },
  mining_dwellerCapHit: {
    achievement: 'Rock bottom',
    description: 'Reach maximum dweller depth'
  },
  mining_craftingLuck: {
    achievement: 'One in a million',
    description: 'Get a pickaxe with top 0.0001% stats'
  },
  mining_timeSpent: {
    description: 'Time spent'
  },
  mining_relicActivesUsed: {
    description: 'Relic actives used'
  },
  mining_bestPrestige0: {
    description: 'Best prestige (ore mine)'
  },
  mining_bestPrestige1: {
    description: 'Best prestige (gas giant)'
  },
  mining_prestigeCount: {
    description: 'Prestiges'
  },

  // Village stats
  village_maxBuilding: {
    achievement: 'Skyscraper',
    description: 'Buildings constructed'
  },
  village_basicResources: {
    achievement: 'Knock on wood',
    description: 'Highest wood, plant fiber or stone amount'
  },
  village_metal: {
    achievement: 'Rust and metal',
    description: 'Highest metal amount'
  },
  village_coin: {
    achievement: 'Capitalist',
    description: 'Coins gained'
  },
  village_water: {
    achievement: 'Aquaeduct',
    description: 'Highest water amount'
  },
  village_knowledge: {
    achievement: 'Mastermind',
    description: 'Highest knowledge amount'
  },
  village_advancedResources: {
    achievement: 'Shiny',
    description: 'Highest hardwood or gem amount'
  },
  village_blessing: {
    achievement: 'Fated',
    description: 'Blessings gained'
  },
  village_offering: {
    achievement: 'Nihilist',
    description: 'Offerings gained'
  },
  village_sacrifice: {
    achievement: 'Black hole',
    description: 'Sacrifices made'
  },
  village_oil: {
    achievement: 'Take their oil!',
    description: 'Highest oil amount'
  },
  village_highestPower: {
    achievement: 'Lights on',
    description: 'Highest power'
  },
  village_minHappiness: {
    achievement: 'Living in hell',
    description: 'Reach minimum happiness'
  },
  village_timeSpent: {
    description: 'Time spent'
  },
  village_relicActivesUsed: {
    description: 'Relic actives used'
  },
  village_bestPrestige0: {
    description: 'Best prestige (workers)'
  },
  village_bestPrestige1: {
    description: 'Best prestige (crafters guild)'
  },
  village_prestigeCount: {
    description: 'Prestiges'
  },

  // Horde stats
  horde_maxZone: {
    achievement: 'Explorer',
    description: 'Maximum zone'
  },
  horde_maxDifficulty: {
    description: 'Maximum difficulty'
  },
  horde_maxZoneSpeedrun: {
    achievement: 'Swift strikes',
    description: 'Maximum zone in under 30 minutes'
  },
  horde_totalDamage: {
    description: 'Total regular attack damage dealt'
  },
  horde_maxDamage: {
    achievement: 'Mighty',
    description: 'Most damage in one regular attack'
  },
  horde_bone: {
    achievement: 'Dog\'s favourite',
    description: 'Bones gained'
  },
  horde_monsterPart: {
    achievement: 'Nothing is wasted',
    description: 'Monster parts gained'
  },
  horde_soulCorrupted: {
    achievement: 'Shepherd of souls',
    description: 'Corrupted souls gained'
  },
  horde_maxCorruptionKill: {
    achievement: 'Challenging evil',
    description: 'Highest corruption enemy defeated'
  },
  horde_maxMastery: {
    achievement: 'One-trick',
    description: 'Highest mastery level'
  },
  horde_totalMastery: {
    achievement: 'Diversity',
    description: 'Total mastery levels'
  },
  horde_blood: {
    achievement: 'Vampire',
    description: 'Blood gained'
  },
  horde_courage: {
    achievement: 'Courageous',
    description: 'Courage gained'
  },
  horde_trinket: {
    achievement: 'Prepared for anything',
    description: 'Sum of all trinket rarities'
  },
  horde_unlucky: {
    achievement: 'Unlucky',
    description: 'Fail with a 99% heirloom chance'
  },
  horde_maxItems: {
    description: 'Most equipment used'
  },
  horde_infiniteScore: {
    achievement: 'Gladiator',
    description: 'Sum of highest # enemies defeated in endless zones'
  },
  horde_warzoneInfiniteScore: {
    description: 'Highest # enemy defeated in endless zone (Warzone)'
  },
  horde_monkeyJungleInfiniteScore: {
    description: 'Highest # enemy defeated in endless zone (Monkey jungle)'
  },
  horde_loveIslandInfiniteScore: {
    description: 'Highest # enemy defeated in endless zone (Love island)'
  },
  horde_timeSpent: {
    description: 'Time spent'
  },
  horde_relicActivesUsed: {
    description: 'Relic actives used'
  },
  horde_bestPrestige0: {
    description: 'Best prestige (equipment)'
  },
  horde_bestPrestige1: {
    description: 'Best prestige (classes)'
  },
  horde_prestigeCount: {
    description: 'Prestiges'
  },

  // Farm stats
  farm_harvests: {
    achievement: 'Lawnmower',
    description: 'Total harvests'
  },
  farm_maxOvergrow: {
    achievement: 'Gardener',
    description: 'Best harvest'
  },
  farm_bestPrestige: {
    achievement: 'Prestigous',
    description: 'Highest crop prestige'
  },
  farm_vegetable: {
    achievement: 'Vegetarian',
    description: 'Vegetables gained'
  },
  farm_berry: {
    achievement: 'Berry good',
    description: 'Berries gained'
  },
  farm_grain: {
    achievement: 'Baker',
    description: 'Grains gained'
  },
  farm_flower: {
    achievement: 'Florist',
    description: 'Flowers gained'
  },
  farm_gold: {
    achievement: 'Monocle',
    description: 'Gold gained'
  },
  farm_care: {
    achievement: 'Precious plants',
    description: 'Care applied'
  },
  farm_totalMystery: {
    description: 'Mystery'
  },

  // Gallery stats
  gallery_beauty: {
    achievement: 'Beautiful',
    description: 'Beauty gained'
  },
  gallery_converter: {
    achievement: 'Endless cycle',
    description: 'Converters gained'
  },
  gallery_colorVariety: {
    achievement: 'Color variety',
    description: 'Color types found'
  },
  gallery_cash: {
    achievement: 'Rich',
    description: 'Cash gained'
  },
  gallery_bestPrestige: {
    description: 'Highest cash in one prestige'
  },
  gallery_highestTierIdea: {
    achievement: 'Big brain',
    description: 'Highest tier idea applied'
  },
  gallery_packageMax: {
    achievement: 'Cardboard fortress',
    description: 'Highest package amount'
  },
  gallery_redDrumMax: {
    achievement: 'Dum dum dum',
    description: 'Highest red drum amount'
  },
  gallery_shapeComboTotal: {
    achievement: 'Collector',
    description: 'Total shapes collected'
  },
  gallery_shapeComboHighest: {
    achievement: 'Genius',
    description: 'Highest shape combo'
  },
  gallery_canvasLevelTotal: {
    achievement: 'Visionary',
    description: 'Total canvas level'
  },
  gallery_hourglassHighest: {
    achievement: 'Borrowed time',
    description: 'Reach 1d of hourglass time'
  },
  gallery_timeSpent: {
    description: 'Time spent'
  },
  gallery_relicActivesUsed: {
    description: 'Relic actives used'
  },
  gallery_prestigeCount: {
    description: 'Prestiges'
  },

  // Other stats
  school_totalPoints: {
    description: 'Total points gained'
  },

  // Meta stats
  meta_totalLevel: {
    achievement: 'Overachiever',
    description: 'Total level of other achievements'
  },
  meta_highestGrade: {
    achievement: 'Know-it-all',
    description: 'Best school grade'
  },
  meta_longestOfflineTime: {
    achievement: 'Comeback',
    description: 'Longest offline time'
  },

  // Custom stats
  custom_hordeBattlepass: {
    description: 'Battle pass level'
  },
};
